import styled from 'styled-components';
import PageCategory from '@src/components/Molecules/PageCategory';
import Aside from '@src/components/Organism/Aside/Index';
import DetailCardTemplate from '@src/components/Template/DetailCard';
import { devices } from '@src/styles/theme';
import { GetServerSideProps } from 'next';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { community } from '@src/services/api';
import { useSingleCommunity } from '@src/hooks/useCommunitys';
import { useRouter } from 'next/router';
import PageTemplate from '@src/components/Template/Page';
import Meta from '@src/components/Meta';
import useAuth from '@src/hooks/useAuth';
import { metaInfo } from '@src/data/meta';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const queryClient = new QueryClient();
  const { id }: any = ctx.query;
  const isValidId = await community.getBoard(id);
  if (isValidId.status >= 400) {
    return {
      redirect: {
        destination: '/404',
        permanent: false,
      },
    };
  }
  await queryClient.prefetchQuery(
    ['detail-page', id],
    async () => await community.getBoard(id)
  );
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};

const DetailCommuinity = () => {
  const router = useRouter();
  const { id }: any = router.query;
  const { fetchBoard } = useSingleCommunity(id);
  const { data: community } = fetchBoard();
  const { fetchProfile } = useAuth();
  const { data: profile } = fetchProfile();
  console.log(community);

  return (
    <>
      <Meta
        title={community?.title}
        description={community?.content}
        ogImage={
          community?.images?.length > 0
            ? community?.images[0]
            : metaInfo.board.ogImage
        }
      />
      <PageTemplate
        AsideIsListPage={true}
        AsideDisabledBody={true}
        href={'/community/board'}
        mainText={'커뮤니티'}
      >
        <DetailCardTemplate
          community={community}
          isMine={
            profile?.uuid !== undefined &&
            profile?.uuid === community?.writer?.uuid
          }
        />
      </PageTemplate>
    </>
  );
};

export default DetailCommuinity;
